"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = JumbotronLead;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function JumbotronLead(props) {
  const classes = 'lead' + (!props.level ? '' : 'text-' + props.level);
  return /*#__PURE__*/_react.default.createElement("p", {
    className: classes,
    "data-test-id": props['data-test-id']
  }, props.children);
}